import { render } from "./IconBadge.vue?vue&type=template&id=18494033"
import script from "./IconBadge.vue?vue&type=script&lang=js"
export * from "./IconBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__